import { useEffect, useRef, useState } from "react";

// Floating action buttons (chat bubble, WhatsApp) sit fixed near the bottom
// nav on every page, so they inevitably sit on top of whatever text scrolls
// under them. Fading them out while the page is actively scrolling — and
// snapping back once it settles — keeps them out of the way mid-read while
// still being available the moment the user stops to look.
export const useIsScrolling = (delay = 150) => {
  const [isScrolling, setIsScrolling] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setIsScrolling(false), delay);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [delay]);

  return isScrolling;
};
